<template>
  <div class="col-3_lg-4_sm-6_xs-12 developers__item-wrap">
    <router-link :to="`/dev-profiles/${data.slug}`" class="developer">
      <img v-lazy="data.avatar_url" alt="" class="developer__image" />
      <div class="developer__image developer__image--fake" lazy="loading"></div>
      <div class="developer__content">
        <div class="developer__content-text">
          <div class="developer__content-name">{{ data.name }}</div>
          <div class="developer__content-role">{{ data.role }}</div>
          <div v-if="data.twitter" class="developer__content-twitter">
            @{{ data.twitter }}
          </div>
        </div>
        <div class="developer__content-divider"></div>
        <div class="developer__content-descr">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    handler(e) {
      console.log(e);
    }
  }
};
</script>
